import { IntegrationEnum } from 'models/InternalIntegrationSetting';
import { Navigate, useParams } from 'react-router-dom';
import useFetchIntegrationAgencySettings from 'hooks/useFetchIntegrationAgencySettings';
import Loader from 'components/loader/Loader';
import useFeatures from 'hooks/useFeatures';
import Breadcrumbs from '../components/breadcrumbs/Breadcrumbs';
import useShouldRedirectToIntegrationsList from './useShouldRedirectToIntegrationsList';
import {
  HeaderContainer,
  IntegrationDetailsWrapper,
} from './IntegrationDetails.styles';
import PropertiesList from './components/propertiesList/PropertiesList';
import PinCodeSizeSelect from './components/pinCodeSizeSelect/PinCodeSizeSelect';

const IntegrationDetails = () => {
  const { id } = useParams();
  const { allowIntegrationsV3 } = useFeatures();

  const { data: integrationAgencySettings, isLoading } =
    useFetchIntegrationAgencySettings({
      enumId: id as IntegrationEnum,
    });

  const integrationName =
    integrationAgencySettings?.integration?.displayName ??
    integrationAgencySettings?.integration?.name;

  const shouldRedirectToIntegrationsList = useShouldRedirectToIntegrationsList(
    id as IntegrationEnum,
  );

  const isRemoteLockIntegration =
    integrationAgencySettings?.integration?.enumId ===
    IntegrationEnum.REMOTELOCK;

  if (!allowIntegrationsV3) {
    return <Navigate to="/integrations-migrated" />;
  }

  if (shouldRedirectToIntegrationsList) {
    return <Navigate to="/integrations" />;
  }

  if (isLoading) {
    return <Loader />;
  }

  return (
    <IntegrationDetailsWrapper>
      <HeaderContainer>
        <Breadcrumbs
          name={integrationName ?? ''}
          logo={integrationAgencySettings?.integration?.logo ?? ''}
        />

        {isRemoteLockIntegration && (
          <PinCodeSizeSelect
            enumId={integrationAgencySettings?.enumId}
            customIntegrationSettings={
              integrationAgencySettings?.agencySettings
                ?.customIntegrationSettings
            }
          />
        )}
      </HeaderContainer>

      {integrationAgencySettings && (
        <PropertiesList integrationAgencySettings={integrationAgencySettings} />
      )}
    </IntegrationDetailsWrapper>
  );
};

export default IntegrationDetails;
